import $ from "jquery";
window.jQuery = $;
require("@fancyapps/fancybox");

jQuery(document).ready(function () {
	if ($('[data-fancybox="gallery"]').length !== 0) {
		$('[data-fancybox="gallery"]').fancybox({
			//options
		});
	}
	if ($(".gallery-icon a").length !== 0) {
		$(".gallery-icon a").fancybox().attr("data-fancybox", "gallery");
	}
});
